import { loadComponent } from '../_Utils/routeComponent';

export default [
  {
    i: 'AccountAndPreferencesCard',
    component: 'AccountAndPreferencesCard',
    data: {
      title: 'AccountAndPreferencesCard',
      titleSecondPart: '',
    },
    breakpoints: {
      xl: {
        w: loadComponent('AccountAndPreferencesCard', 'breakpoints').lg.w,
        h: loadComponent('AccountAndPreferencesCard', 'breakpoints').lg.h,
        minW: loadComponent('AccountAndPreferencesCard', 'breakpoints').lg.minW,
        minH: loadComponent('AccountAndPreferencesCard', 'breakpoints').lg.minH,
        x: 0,
        y: 0,
      },
      lg: {
        w: loadComponent('AccountAndPreferencesCard', 'breakpoints').lg.w,
        h: loadComponent('AccountAndPreferencesCard', 'breakpoints').lg.h,
        minW: loadComponent('AccountAndPreferencesCard', 'breakpoints').lg.minW,
        minH: loadComponent('AccountAndPreferencesCard', 'breakpoints').lg.minH,
        x: 0,
        y: 0,
      },
      md: {
        w: loadComponent('AccountAndPreferencesCard', 'breakpoints').md.w,
        h: loadComponent('AccountAndPreferencesCard', 'breakpoints').md.h,
        minW: loadComponent('AccountAndPreferencesCard', 'breakpoints').md.minW,
        minH: loadComponent('AccountAndPreferencesCard', 'breakpoints').md.minH,
        x: 0,
        y: 0,
      },
      sm: {
        w: loadComponent('AccountAndPreferencesCard', 'breakpoints').sm.w,
        h: loadComponent('AccountAndPreferencesCard', 'breakpoints').sm.h,
        minW: loadComponent('AccountAndPreferencesCard', 'breakpoints').sm.minW,
        minH: loadComponent('AccountAndPreferencesCard', 'breakpoints').sm.minH,
        x: 0,
        y: 0,
      },
      xs: {
        w: loadComponent('AccountAndPreferencesCard', 'breakpoints').xs.w,
        h: loadComponent('AccountAndPreferencesCard', 'breakpoints').xs.h,
        minW: loadComponent('AccountAndPreferencesCard', 'breakpoints').xs.minW,
        minH: loadComponent('AccountAndPreferencesCard', 'breakpoints').xs.minH,
        x: 0,
        y: 0,
      },
    },
  },
  {
    i: 'ManageProjectsCards',
    component: 'ManageProjectsCards',
    data: {
      title: 'ManageProjectsCards',
      titleSecondPart: '',
    },
    breakpoints: {
      xl: {
        w: loadComponent('ManageProjectsCards', 'breakpoints').lg.w,
        h: loadComponent('ManageProjectsCards', 'breakpoints').lg.h,
        minW: loadComponent('ManageProjectsCards', 'breakpoints').lg.minW,
        minH: loadComponent('ManageProjectsCards', 'breakpoints').lg.minH,
        x: 0,
        y: 0,
      },
      lg: {
        w: loadComponent('ManageProjectsCards', 'breakpoints').lg.w,
        h: loadComponent('ManageProjectsCards', 'breakpoints').lg.h,
        minW: loadComponent('ManageProjectsCards', 'breakpoints').lg.minW,
        minH: loadComponent('ManageProjectsCards', 'breakpoints').lg.minH,
        x: 0,
        y: 0,
      },
      md: {
        w: loadComponent('ManageProjectsCards', 'breakpoints').md.w,
        h: loadComponent('ManageProjectsCards', 'breakpoints').md.h,
        minW: loadComponent('ManageProjectsCards', 'breakpoints').md.minW,
        minH: loadComponent('ManageProjectsCards', 'breakpoints').md.minH,
        x: 0,
        y: 0,
      },
      sm: {
        w: loadComponent('ManageProjectsCards', 'breakpoints').sm.w,
        h: loadComponent('ManageProjectsCards', 'breakpoints').sm.h,
        minW: loadComponent('ManageProjectsCards', 'breakpoints').sm.minW,
        minH: loadComponent('ManageProjectsCards', 'breakpoints').sm.minH,
        x: 0,
        y: 0,
      },
      xs: {
        w: loadComponent('ManageProjectsCards', 'breakpoints').xs.w,
        h: loadComponent('ManageProjectsCards', 'breakpoints').xs.h,
        minW: loadComponent('ManageProjectsCards', 'breakpoints').xs.minW,
        minH: loadComponent('ManageProjectsCards', 'breakpoints').xs.minH,
        x: 0,
        y: 0,
      },
    },
  },
];
